import * as React from 'react';
import { observer } from 'mobx-react';

import CopyToClipboardStore from './Store';
import CopyToClipboardState from './CopyToClipboardState';
import CopyToClipboardReactions from './Store/Reactions';

interface Props {
  copyText: string;
}

class CopyToClipboard extends React.Component<Props> {
  private copyToClipboardStore: CopyToClipboardStore = new CopyToClipboardStore(
    this.props.copyText,
  );

  render() {
    return (
      <div data-clipboard-text={this.props.copyText}>
        <CopyToClipboardState store={this.copyToClipboardStore} />
        <CopyToClipboardReactions store={this.copyToClipboardStore} />
      </div>
    );
  }
}
export default observer(CopyToClipboard);
